/**
 * Copy for the storage & links screen.
 *
 * Strings live here rather than inline because several are used in more than one
 * place (the confirm and the toast, the empty state and the header note), and a
 * user-facing phrase that drifts between two of them reads as two features.
 */
export enum StorageManagerMessage {
  Title = 'Storage & links',
  DeviceHeading = 'On this device',
  DeviceHint = 'Media stored by the app. Deleting an item frees only what nothing else is using.',
  DeviceUnknown = 'Not measured yet',
  ReferencedHeading = 'Available to stream',
  ReferencedHint = 'Media your library uses that is not on this device. It plays over the internet — download an item from its own page to keep it here.',
  ReferencedNone = 'Everything your library uses is on this device.',
  ProtectedTitle = 'Protected from cleanup',
  ProtectedYes = 'Your browser has agreed not to clear this app’s data.',
  ProtectedNo = 'Your browser may clear this app’s data if the device runs low on space. Back up anything you cannot lose.',
  ProtectedUnknown = 'This device would not say whether app data can be cleared.',
  SearchPlaceholder = 'Search your library',
  Empty = 'Nothing here yet.',
  EmptySearch = 'No items match that search.',
  UsedByHeading = 'Used by',
  UsedByNone = 'Nothing uses this — safe to delete.',
  UsedByHint = 'Delete these first, or remove this item from them.',
  FreesLabel = 'Frees',
  TotalLabel = 'Total',
  SelectionPrefix = 'selected',
  Delete = 'Delete',
  Cancel = 'Cancel',
}

/**
 * Copy for media an activity names but this device does not hold.
 *
 * The tone is deliberate: nothing here blocks the workout. The exercise keeps
 * running on its timer whatever the user chooses, so every string offers a way
 * forward rather than reporting a fault.
 */
export enum MissingMediaMessage {
  Title = 'Not on this device',
  Body = 'This exercise has a video or track saved in the cloud. The exercise still runs without it.',
  Download = 'Download',
  Downloading = 'Downloading…',
  Dismiss = 'Continue without it',
  /** Shown once a download has proven the cloud does not have it either. */
  GoneTitle = 'This media is no longer available',
  GoneBody = 'It is not on this device and not in your cloud, so there is nothing left to download. You can remove it from this exercise, and delete the exercise afterwards if you no longer want it.',
  Remove = 'Remove it from this exercise',
  Removed = 'Removed — the exercise now runs on its timer',
  DownloadFailed = 'Could not download it just now. Try again when you have a connection.',
}
